import React, { ReactNode } from 'react'
import { Modal } from 'antd'
import styled from '@emotion/styled'
import { CommonButton } from './CommonButton'

interface ConfirmationModalProps {
  title: string
  confirmLabel: string
  isOpen: boolean
  onOk: () => void
  onCancel: () => void
  children: ReactNode
  confirmLoading?: boolean
  hideCancel?: boolean
  confirmVariant?: 'danger' | 'default'
}

const ConfirmationModal = ({
  title,
  confirmLabel,
  isOpen,
  onOk,
  onCancel,
  children,
  confirmLoading = false,
  hideCancel = false,
  confirmVariant = 'danger'
}: ConfirmationModalProps) => {
  return (
    <Modal open={isOpen} onCancel={onCancel} closable={false} footer={false}>
      <ModalTitle>{title}</ModalTitle>
      {children}
      <Actions>
        {!hideCancel && (
          <CommonButton onClick={onCancel} disabled={confirmLoading}>
            Cancel
          </CommonButton>
        )}
        <CommonButton
          type={confirmVariant === 'danger' ? 'danger' : 'filled'}
          onClick={onOk}
          loading={confirmLoading}
          disabled={confirmLoading}
        >
          {confirmLabel}
        </CommonButton>
      </Actions>
    </Modal>
  )
}

export const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  line-height: 1;
  margin-bottom: 16px;
`

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #4a4a68;
  margin-bottom: 32px;
`

const Actions = styled.div`
  margin-top: 32px;

  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export default ConfirmationModal
